// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__d9YUC","loading":"Loader_loading__34RWf"};